/**
 * Locked company brand tokens, taken from the AST PowerPoint template
 * (AST PPT Presentation.pptx). The color picker may only use these.
 */
export const BRAND = {
  blue: '#005EAD',
  bright: '#0070C0',
  sky: '#95B9DB',
  ink: '#212121',
  gray: '#595959',
  surface: '#EEF4FA',
  white: '#FFFFFF',
} as const;

export const BRAND_COLORS = [
  { name: 'AST Blue', hex: BRAND.blue },
  { name: 'Bright Blue', hex: BRAND.bright },
  { name: 'Sky', hex: BRAND.sky },
  { name: 'Ink', hex: BRAND.ink },
  { name: 'Gray', hex: BRAND.gray },
  { name: 'Light Surface', hex: BRAND.surface },
  { name: 'White', hex: BRAND.white },
] as const;

/** Template typefaces: Lora for cover titles, Arial for content, Poppins for labels. */
export const FONTS = {
  display: 'Lora',
  body: 'Arial',
  label: 'Poppins',
} as const;

export type FontRole = keyof typeof FONTS;

export const FONT_STACKS: Record<FontRole, string> = {
  display: '"Lora", Georgia, serif',
  body: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  label: '"Poppins", Arial, sans-serif',
};

/** Template artwork served from /public. */
export const ASSETS = {
  logo: '/ast-logo.png',
  logoWhite: '/template/ast-logo-white.png',
  coverBackground: '/template/cover-bg.jpg',
  sideStrip: '/template/side-strip.jpg',
} as const;

export const CANVAS = {
  width: 1280,
  height: 720,
  aspect: 16 / 9,
} as const;

/** PowerPoint LAYOUT_16x9 inches (same as the template's 9144000 × 5143500 EMU). */
export const PPTX = {
  widthIn: 10,
  heightIn: 5.625,
} as const;

export function pxToInches(px: number, axis: 'x' | 'y' = 'x'): number {
  return axis === 'x' ? (px / CANVAS.width) * PPTX.widthIn : (px / CANVAS.height) * PPTX.heightIn;
}

/** Canvas px → PowerPoint points (1280 px = 10 in = 720 pt). */
export function pxToPt(px: number): number {
  return Math.round(px * (PPTX.widthIn * 72 / CANVAS.width) * 10) / 10;
}

export const THEMES = {
  ast_standard: {
    id: 'ast_standard',
    name: 'AST Standard',
    accent: BRAND.blue,
    titleBg: BRAND.blue,
  },
} as const;

export type ThemeId = keyof typeof THEMES;

export const CONFIDENTIALITY = 'CONFIDENTIAL — Internal Use Only';
export const COMPANY_NAME = 'AST';
export const COMPANY_LEGAL_NAME = 'ADVANCED SUBSTRATE TECHNOLOGIES PTE. LTD.';
